export const PURCHASING_SETTINGS_SCOPES = ["company", "units", "access", "orders", "stock_requisitions", "stock_transfers", "catalog", "locations", "whatsapp", "operation_closures"];

// Explicit section choices override the compatibility defaults for older roles.
export function normalizePurchasingSettingsPermissions(permissions = {}) {
  const normalized = { ...permissions };
  for (const scope of PURCHASING_SETTINGS_SCOPES) {
    for (const action of ["view", "update"]) {
      const key = `purchasing.settings.${scope}.${action}`;
      if (!Object.prototype.hasOwnProperty.call(normalized, key)) {
        normalized[key] = permissions?.[`purchasing.settings.${action}`] === true;
      }
    }
  }
  return normalized;
}

export function hasPurchasingSettingsPermission(user, scope, action) {
  return Number(user?.id) === 1 ||
    normalizePurchasingSettingsPermissions(user?.permissions)[`purchasing.settings.${scope}.${action}`] === true;
}

export function hasPurchasingApprovalSettingsAccess(user) {
  return ["orders", "stock_requisitions", "stock_transfers", "catalog"]
    .some((scope) => hasPurchasingSettingsPermission(user, scope, "view"));
}

export function hasAnyPurchasingSettingsAccess(user) {
  return PURCHASING_SETTINGS_SCOPES.some((scope) => hasPurchasingSettingsPermission(user, scope, "view"));
}
